import { useRef } from 'react'

import { createPortal } from 'react-dom'

import { DropdownPortalProps } from './interface'
import { useClickOutside } from '@/hooks/use-click-outside'

export const CustomDropdown = ({
  top,
  left,
  onClose,
  children
}: DropdownPortalProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  useClickOutside<HTMLDivElement>(dropdownRef, onClose)

  return createPortal(
    <div
      ref={dropdownRef}
      role='menu'
      tabIndex={-1}
      style={{
        position: 'fixed',
        top,
        left,
        zIndex: 9999,
        backgroundColor: '#1e1e1e',
        borderRadius: 8,
        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
        padding: '8px 0',
        minWidth: 200
      }}
      onKeyDown={e => {
        if (e.key === 'Escape') {
          onClose()
        }
      }}
    >
      {children}
    </div>,
    document.body
  )
}
